import { BareActionContext } from 'vuex-typex'
import { AuthState } from '../state'
import { RootState } from '@/store/'
import { IUser } from '../../../model/user'
import authStore from '../auth-store'
import authUtils from './auth-utils'

export default async function facebookLogin(context: BareActionContext<AuthState, RootState>) {
  if (!authStore.isAuthenticated) {
    authUtils.authService.facebookLogin().then((user: IUser | null) => {
      if (!user) {
        authStore.commitPurgeUser()
      } else {
        authStore.commitSetUser({ user: user })
      }
    })
  }
}
